import { useQuery } from '@tanstack/react-query';
import { fetchHello } from './lib/api';

/**
 * Phase 1 Foundation 疎通確認画面.
 *
 * Cloudflare Access ログイン後に `Hello, <email>` を表示するだけ.
 * Phase 2 で KPI ダッシュボード等の本体画面に置き換える.
 */
export function HelloPage({ apiBaseUrl }: { apiBaseUrl: string }) {
  const query = useQuery({
    queryKey: ['admin-ops-hello'],
    queryFn: () => fetchHello(apiBaseUrl),
  });

  return (
    <main className="mx-auto max-w-3xl px-6 py-12">
      <header className="mb-8">
        <p className="text-xs uppercase tracking-wider text-slate-500">ALYS Internal</p>
        <h1 className="mt-1 text-2xl font-semibold text-slate-900">AI Inbox Core Operations</h1>
        <p className="mt-2 text-sm text-slate-600">
          Phase 1 Foundation 疎通確認 / Cloudflare Access &amp; alys_owner 認証
        </p>
      </header>

      <section className="rounded-md border border-slate-200 bg-white p-6">
        {query.isLoading && <p className="text-sm text-slate-500">Loading…</p>}
        {query.isError && (
          <p className="text-sm text-rose-600">
            API 疎通に失敗しました: {(query.error as Error).message}
          </p>
        )}
        {query.data && (
          <div className="space-y-3">
            <p className="text-lg font-medium text-slate-900">{query.data.message}</p>
            <dl className="grid grid-cols-3 gap-2 text-xs text-slate-600">
              <dt className="text-slate-400">actor.email</dt>
              <dd className="col-span-2 font-mono">{query.data.actor.email}</dd>
              <dt className="text-slate-400">actor.subject</dt>
              <dd className="col-span-2 font-mono">{query.data.actor.subject || '(empty)'}</dd>
            </dl>
          </div>
        )}
      </section>
    </main>
  );
}
